<!-- eslint-disable vue/no-mutating-props -->
<template>
  <Dialog v-model:visible="visible" style="width:43%;">
    <div>
      <h3>{{ _t('label_text_colour') }}</h3>
      <span v-for="(color, i) in iconColors" :key="color" class="p-col-3 p-text-center">
        <label :for="`color${i}`">
          <span :style="`background-color: ${color}; border: 1px solid gray`" class="color_sample p-mb-2"/>
          <RadioButton :id="`color${i}`"
                       v-model="button.textColor"
                       :disabled="!isEditable"
                       :value="color"
                       name="color"
          />
        </label>
      </span>
    </div>
  </Dialog>
</template>

<script>
/* eslint-disable vue/no-mutating-props */
export default {
  name: 'ColorPickerDialog',
  props: {
    modelValue: { type: Boolean, required: true },
    button: { type: Object, default: null },
    iconColors: { type: Array, required: true },
    isEditable: { type: Boolean, default: false },
  },
  emits: ['update:modelValue'],
  computed: {
    visible: {
      get() { return this.modelValue },
      set(v) { this.$emit('update:modelValue', v) },
    },
  },
}
</script>

<style scoped>
.color_sample {
  display: inline-block;
  width: 48px;
  height: 48px;
  border-radius: 4px;
  margin: 0 auto;
}
</style>
